var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right mb-2 d-lg-none global__filter__close"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.close}},[_c('i',{staticClass:"fas fa-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }